import { Component, OnInit  } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Api, ErrorCodes, ErrorHelper, Session, Ui } from '../services/index';
import {  PasswordReset,Patient } from '../models';
import { NotificationsService } from 'angular2-notifications';
import { Location, APP_BASE_HREF } from '@angular/common';

//Use this to show the password only (minimun needed) display.
//http://localhost:4200/#/auth?auth=abc123&userid=123&email=rusty16@gmail.com&token=3456ts&display=lm
//Us this to show the set password display.
//http://localhost:4200/#/auth?auth=abc123&userid=123&email=rusty16@gmail.com&token=3456ts&display=sp

@Component({
    selector: 'page-auth-partner',
    templateUrl: 'auth.partner.html' 
})
export class AuthPartner {
    public isRequesting: boolean;
    model: any = {};
    loading: boolean = false;
    returnUrl: string;
    setPassword = false;
    loginMin = false;//only shows password field, username is hidden.
    form: FormGroup;
    submitted: boolean;
    userEmail: string;
    pathString: string; 
    userId:number;


    constructor( private route: ActivatedRoute, 
        public formBuilder: FormBuilder,
        private router: Router,
        public session: Session,
        private loader: Ui,
        private service: NotificationsService,
        private ui: Ui,
        public api: Api ) {

          
        this.form = this.formBuilder.group(
            {
                password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
                confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(6),])]
            }, {
                validator: this.matchingPasswords('password', 'confirmPassword')
            });
    }

    ngOnInit() {
       if (!this.session.isAuthenticated) {
            this.session.logout(false);
        }
        this.session.patient = new Patient();

        let displayType = '';
        this.route.queryParams        
        .subscribe(params => {
            console.log('auth params:' , params);
            displayType  = params.display;
            this.model.username = params.email; 
            Api.bearerToken = params.token;
            this.userId = params.userid;
            this.userEmail = params.email;
        });
        this.session.jwtToken =Api.bearerToken ;

        console.log('displayType:', displayType);
        switch(displayType){
            case 'sp': //set password
                this.setPassword = true;
                this.loginMin = false;
                break;
            case 'lm': //login with minimum requirement.
                this.setPassword = false;
                this.loginMin = true;
                break;
        }
        console.log('auth.loginMin:', this.loginMin);
        console.log('auth.setPassword:', this.setPassword);
        console.log('auth.this.model.username :', this.model.username  );
        console.log('auth.Api.bearerToken:', Api.bearerToken );

     
    }


    private matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
        return (group: FormGroup) => {
            let passwordInput = group.controls[passwordKey];
            let passwordConfirmationInput = group.controls[confirmPasswordKey];
            if (passwordInput.value !== passwordConfirmationInput.value) {
                return passwordConfirmationInput.setErrors({ notEquivalent: true })
            }
        }
    }


    login() {
        console.log('auth.login.username :', this.model.username  );
        this.loading = true;
        this.isRequesting = true;
    
        this.session.login(this.model.username, this.model.password)
          .subscribe(success => {
            this.session.setAuthenticated(true);
            this.isRequesting = false;
            this.loading = false;
            this.router.navigate(['/dashboard']);
          }, ex => {
            console.log('Invalid Login Credentials');
            this.loading = false;
          });
      }
    
      forgotPassword() {
        this.router.navigate(['/forgot-password']);
      }
    
      signUp() {
        this.router.navigate(['/signup']);
      }

      ShowSetPassword(){
        this.setPassword = true;
        this.loginMin = false;
      }
   
      ShowLogin(){
        this.setPassword = false;
        this.loginMin = true;
      }

      submitTapped() {
        this.loading = true;
        this.session.patient.password = this.form.value.password;
        let pwrest = new PasswordReset();
        pwrest.userID = this.userId;
        pwrest.userEmail = this.userEmail;
        pwrest.password = this.form.value.password;
        this.api.setPassword(pwrest).subscribe(res => {
           
            if ( this.userId > 0 ) {
                let sessionJWT = res;
                let login = this.session.loginWithToken(sessionJWT)
                .subscribe(success => {
                  this.loading = false;
                  this.session.setAuthenticated(true);
                  this.router.navigate(['/dashboard']);
                }, ex => {
                  this.loading = false;
                  console.log('Invalid Login Credentials');
                });
            } else{ 
                this.loading = false;
                this.router.navigate(['/#/login']); 
            }
           
        }, err => {
            this.service.error('Error. Please try again in a moment.');
            this.loading = false;
        });
       
    }
}
